import gql from 'graphql-tag'

export default gql`
  query CruiseLine($nickname: String!) {
    cruiseLine(nickname: $nickname) {
      id
      name
      destinations(where: { active: true }) {
        id
        keywords{
          id
          keyword
        }
        name
        image
        imageURL
        imageURL2
        thumbnail
        link
        country
        subtitle
        description
        offerId
        startDate
        endDate
        checkInDate
        checkOutDate
        onePerson
        twoPerson
        threePerson
        fourPerson
        fivePerson
        sixPerson
        sevenPerson
        singleAdditional
        doubleAdditional
        tripleAdditional
        quadAdditional
        children
        childrenPrice
        childrenAgeLimit
        recommended
        preferred
        bestSeller
        active
        descriptivo
      }
      flotas (where: { active: true }){
        id
        name
        keywords{
          id
          keyword
        }
        image
        imageURL
        thumbnail
        link
        country
        subtitle
        description
        offerId
        startDate
        endDate
        checkInDate
        checkOutDate
        onePerson
        twoPerson
        threePerson
        fourPerson
        fivePerson
        sixPerson
        sevenPerson
        singleAdditional
        doubleAdditional
        tripleAdditional
        quadAdditional
        children
        childrenPrice
        childrenAgeLimit
        recommended
        active
        bestSeller
        preferred
        descriptivo
      }
    }
  }
`
